import { FC } from 'react'
import Spinner from './Spinner'

type FullScreenSpinnerProps = {
  styles?: string
}

const FullScreenSpinner: FC<FullScreenSpinnerProps> = ({ styles }) => (
  <div className={`flex m-auto h-screen w-36 ${styles}`}>
    <Spinner />
  </div>
)

export default FullScreenSpinner
